import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import { ResearchParticipant } from "@/views/research/research.types";
import { ClientDDL, ClientInfo } from "@/views/base/base.types";
import { ErrorBag, Field } from "vee-validate";
import moment from "moment";

@Component({
  computed: {
    ...mapFields("Research", [
      "sortBy", 
      "sortDesc", 
      "searchQuery",
      "researchParticipants",
      "selectedResearchParticipant"
    ]),
    ...mapState("Base", [
      "selectedClientDDL",
      "clientInfo"
    ])
  }
})
export default class ResearchMixin extends Vue {
  researchParticipants!: ResearchParticipant[];
  selectedResearchParticipant!: ResearchParticipant;
  selectedClientDDL!: ClientDDL;
  clientInfo!: ClientInfo[];

  sortBy!: string;
  sortDesc!: boolean;
  searchQuery!: string;

  veeFields!: Field;
  veeErrors!: ErrorBag;

  fields = [
    {
      key: 'action',
      label: ''
    },
    {
      key: 'patientId',
      label: 'Participant'
    },
    {
      key: 'phoneNumber',
      label: 'Phone #'
    },
    {
      key: 'researchDay1',
      label: 'Research Day 1'
    },
    {
      key: 'day',
      label: 'Day'
    },
    {
      key: 'dob',
      label: 'DOB'
    },
    {
      key: 'gender',
      label: 'Gender'
    },
    {
      key: 'dsm5',
      label: 'DSM-5'
    },
    {
      key: 'watchId',
      label: 'Watch ID'
    },
    {
      key: 'medication',
      label: 'Medication'
    },
    {
      key: 'induction',
      label: 'Induction'
    },
  ]

  get selectedClient() {
    return this.clientInfo.find(
      item => item.clientId === this.selectedClientDDL.value
    ) ?? new ClientInfo;
  }

  get selectedResearchDuration() {
    return this.clientInfo.find(
      item => item.clientId === this.selectedClientDDL.value
    )?.researchDuration ?? 0;
  }

  formatDate(date: string | Date | null | undefined): string {
    if (!date) return "";
    return moment(date, "YYYY-MM-DD", true).format("MM/DD/YYYY");
  }

  formatDateTime(dateTime: string | Date | null | undefined): string {
    if (!dateTime) return "";
    return moment(dateTime, "MM/DD/YYYY HH:mm:ss", true).format("MM/DD/YYYY h:mm A");
  }

  formatTime(time: string | Date | null | undefined): string {
    if (!time) return "";
    return moment(time, ["HH:mm:ss.SSSSSSS", "HH:mm:ss"]).format("h:mm A");
  }
}